import Grid from '@mui/material/Grid';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { handleStatus } from '../../../../shared/utils';
import { IResponseCCS0011 } from '../../../../shared/services/types/response';
import { maskCPFCNPJ } from '../../../../shared/utils/mask';

interface CardCSS0011Props {
  ccsValue: IResponseCCS0011;
  handleOpenModal: (item?: IResponseCCS0011) => void;
}

const CardCcs0011 = ({ ccsValue, handleOpenModal }: CardCSS0011Props) => {
  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={2} key={ccsValue?.id}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom color="secondary.main">
              {ccsValue?.number_control_ccs}
            </Typography>
            <Typography variant="body2">
              Data de envio do Bacen:{' '}
              {moment(ccsValue?.date_time_bacen).format('DD/MM/yyyy')}
            </Typography>
            <Typography m={'0 2 0 2'} variant="body2">
              Documento:
            </Typography>
            <Typography color="primary.main" variant="body2">
              {maskCPFCNPJ(ccsValue?.cpf_cnpj_person)}
            </Typography>
            <Typography variant="body2">
              Criado em: {moment(ccsValue?.created_at).format('DD/MM/yyyy')}
            </Typography>
            <Typography variant="body2">
              ID Controle: {ccsValue?.number_control_if}
            </Typography>
            <Typography mt={1} textAlign={'end'} variant="body2">
              Status: {handleStatus(ccsValue?.status)}
            </Typography>
          </CardContent>
          <CardActions>
            <Button size="small" onClick={() => handleOpenModal()}>
              Detalhes
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </>
  );
};

export default CardCcs0011;
